export const reconciliationTheme = {
  parameter: {
    active: {
      bg: 'palette.surface.4',
      borderColor: 'palette.primary.40',
      borderRadius: '12px',
      borderWidth: '1px',
    },
    base: {
      bg: 'palette.surface.3',
      borderColor: 'palette.surface.3',
      borderRadius: '12px',
      borderWidth: '1px',
    },
    bg: 'palette.surface.3',
  },
  resolveSidebar: {
    borderColor: 'palette.surface.2',
    borderRadius: '0px',
    borderWidth: '1px',
  },
  values: {
    borderBottom: 'palette.primary.40',
  },
};
